<div class="tooltip" [ngClass]="{'tooltip__big': (noOfOffers > NUMBER_1)}">
  <div class="tooltip__overlay">
    <span class="tooltip__info">
      <mm-icon name="alert-info-small"></mm-icon>
    </span>

    <span class="tooltip__content" *ngIf="!(noOfOffers > NUMBER_1)">
      {{ 'CATALOG.DETAILS_PAGE.OUT_OF_ORDER_NOTIFICATION.ADD_TO_CART.TOOL_TIP_LABEL' | translate : {quantity:
      currentOffer.quantity} }}
    </span>

    <span class="tooltip__content" *ngIf="(noOfOffers > NUMBER_1)">
      {{ 'CATALOG.DETAILS_PAGE.OUT_OF_ORDER_NOTIFICATION.ADD_TO_CART.TOOL_TIP_LABEL' | translate : {quantity:
      currentOffer.quantity} }}
      {{ 'CATALOG.DETAILS_PAGE.OUT_OF_ORDER_NOTIFICATION.ADD_TO_CART.LABEL_MORE_OFFER' | translate }}
    </span>

    <a (click)="closeDialog()" class="tooltip__close">
      <mm-icon name="close"> </mm-icon>
    </a>
  </div>
</div>